import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScripts } from '../../../helpers/Utils';

export function SecurityUserPage(): React.ReactElement {
  const currentSecurity = useSecurity('Security', 'User');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScripts([
        'Areas/Admin/Scripts/Resources/en/res.User.en.js',
        'Areas/Admin/Scripts/Resources/en/Types.en.js',
        'Areas/Admin/Scripts/Enums.js',
        'Areas/Admin/Scripts/User/Index.js',
      ]);
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
